export const IDENTITY_TYPE = {
  GENERAL: 0, // 普通的
  SALE: 1, // 銷售
};

export const SocketStatusEnum = {
  OPEN: 'OPEN',
  CONNECTING: 'CONNECTING',
  CLOSED: 'CLOSED',
};

export const LocalStatusEnum = {
  SENDING: 1, // 正在發送
  ERROR: 2, // 發送失敗
};

export const SocketTypeEnum = {
  ERROR: 'error',
  WARNING: 'warning',
  MSG_LIST: 'msgList',
  SEND_MSG: 'sendMsg',
  SEND: 'send',
  BIND: 'bind', // 綁定聊天室（這個項目好像用不到）
  MSG_NO_READ_NUM: 'msgNoReadNum', // 獲取未讀數
  CLICK: 'click', // 點擊事件
  SEND_MSG_LIMIT: 'sendMsgLimit', // 次數上限
  ROOM_INFO: 'roomInfo',
  HIGH_SERVICE_INFO: 'highServiceInfo',
  READ_MSG: 'readMsg',
  PHRASE_LIST: 'phraseList', // 快速回復
  SET_PHRASE: 'setPhrase', // 編輯快速回復
  DEL_PHRASE: 'delPhrase', // 刪除快速回復
  VOICE_COMPLETE: 'voiceComplete',
  IS_TO_USER_ONLINE: 'isToUserOnline',
  WITHDRAW_MSG: 'withdrawMsg', // 撤回消息
  DEL_MSG: 'delMsg',
  TRANSLATE_NOTICE: 'translateNotice', // AI 實時翻譯通知
  USER_USABLE_COUPON: 'userUsableCoupon', // 用户可用的優惠券
  ASSISTANT_MANUAL_MODE: 'assistantManualMode', // 助理角色人工服務協議
};

/**
 * 全局socket的類型
 */
export const GlobalSocketTypeEnum = {
  MSG_NO_READ_NUM: SocketTypeEnum.MSG_NO_READ_NUM,
  SALE_NEW_MSG: 'Sale_NewMsg', // 新消息內容數據
  SALE_CHAT_READ_MSG: 'Sale_Chat_ReadMsg', // 諮詢室用户消息已讀
  SALE_USER_NICKNAME_REMARK: 'Sale_UserNickname_Remark', // 用户暱稱備註
  SALE_SC_ORDER_NOTIFICATION: 'Sale_Sc_Order_Notification', //閃測訂單提醒
  BUY_SERVICE_TIPS: 'buyServiceTips', // 用戶購買文字諮詢服務提示
};

export const MsgTypeEnum = {
  TEXT: 1, // 文本
  IMG: 2, // 圖片
  MEDIA: 3, // 媒體消息，通常是音頻
  REWARD_AMOUNT: 5, // 打賞金額
  RECOMMEND_SERVICE: 6, // 推薦服務
  PURCHASED_SERVICE: 7, // 購買服務
  TEACHER_PROFILE: 8, // 老師簡介
  COUPON: 10, // 優惠券
  RECOMMEND_GOODS: 11, // 推薦吉品
  CALL_RESULT: 13, // 連線結果
  LINK_TIPS: 14, // 帶鏈接的提示消息
  PREMIUM_SERVICE_ENDS: 20, // 高級諮詢室服務結束
  AUTOMATIC_RESPONSE: 26, // 自動回覆
  PAGE_JUMP_TIPS: 27, // 帶頁面跳轉的提示消息
  SYSTEM_SERVICE_RECOMMEND: 29, // 系統推薦老師服務
  TAROT_TOOL_CARD: 32, // 塔羅工具卡片
  CS_CARD: 35, // 測算卡片
  INVITE_CALL: 37, // 邀請通話
  SHAN_CE_ORDER: 39, // 閃測下單成功卡片
  TEACHER_CARD: 47, // 老師卡片
  CHAT_HISTORY: 35, // 聊天記錄
  ORDER_INFO_CARD: 46, // 訂單詳情卡片
  EVALUATE_CARD: 48, // 評價卡片
  COMMON_QUESTION: 49, // 常見問題
  REPROT_EVALUATION: 45, // 解讀報告評價
};
